import { AcornsIcon } from '@acorns/icons'
import { Heading2 } from '@acorns/web-components'
import styled from 'styled-components'

import GradientGif from 'assets/images/passions-customize.gif'
import { style } from 'theme'

export const CustomizePortfolioItem = styled.div<{
  screen?: string
}>`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${(props) => (props.screen === 'portfolio' ? 10 : 0)}px;
  margin-top: ${(props) => (props.screen === 'portfolio' ? 40 : 30)}px;
  background: url(${GradientGif}) no-repeat;
  background-size: cover;
  border-radius: 10px;
  overflow: hidden;
  width: 100%;
  cursor: pointer;
  height: 186px;

  @media (max-width: ${style((theme) => theme.breakpoints.sm)}px) {
    height: 158px;
    margin-top: ${(props) => (props.screen === 'portfolio' ? 0 : 30)}px;
  }
`

export const CustomizeHeaderText = styled(Heading2)`
  color: ${style((theme) => theme.colors.white)};
  font-size: 22px;
  line-height: 30px;
  padding-bottom: 10px;
  width: 280px;
  margin-top: 40px;
  @media (max-width: 912px) {
    width: 200px;
    font-size: 18px;
    line-height: 26px;
  }
  @media screen and (max-width: ${style((theme) => theme.breakpoints.md)}px) {
    width: 260px;
    font-size: 22px;
    line-height: 30px;
  }
  @media screen and (max-width: ${style((theme) => theme.breakpoints.sm)}px) {
    width: 231px;
    font-size: 18px;
    line-height: 26px;
    margin-top: 30px;
  }
  @media screen and (max-width: 320px) {
    width: 170px;
    font-size: 14px;
    line-height: 22px;
  }
`

export const DetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-self: center;
  width: 100%;
  padding-left: 30px;
  height: 186px;

  @media screen and (max-width: ${style((theme) => theme.breakpoints.sm)}px) {
    height: 158px;
    padding-left: 20px;
  }
`

export const BrandsImg = styled.img<{
  screen?: string
}>`
  margin: ${(props) =>
    props.screen === 'portfolio'
      ? '-15px -110px -15px 0'
      : '-15px -15px -15px 0'};
  width: 100%;
  height: ${(props) => (props.screen === 'portfolio' ? '212px' : 'auto')};
  @media screen and (max-width: 1029px) {
    display: none;
  }
`

export const CustomizeLearnMoreButton = styled.button`
  background: transparent;
  border: none;
  color: ${style((theme) => theme.colors.white)};
  display: flex;
  font-size: 16px;
  font-weight: 600;
  padding: 0;
`

export const StyledArrowRight = styled(AcornsIcon)`
  margin-left: 8px;
  & path {
    fill: ${style((theme) => theme.colors.white)};
  }
`

export const MobileImg = styled.img`
  width: 243px;
  margin: -70px -80px 0 0;
  @media screen and (max-width: 1029px) {
    display: flex;
  }
  @media screen and (max-width: 912px) {
    margin: -75px -50px 0 0;
  }
  @media screen and (max-width: ${style((theme) => theme.breakpoints.md)}px) {
    margin: -140px -20px 0 0;
  }
  @media screen and (max-width: 540px) {
    margin: -80px -60px 0 0;
  }
  @media screen and (max-width: ${style((theme) => theme.breakpoints.sm)}px) {
    width: 55%;
    margin: -50px -40px 0 0;
  }
  display: none;
`

export const LearnMoreContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

export const LearnMoreSpan = styled.span`
  display: flex;
  text-align: left;
  white-space: nowrap;
  padding-bottom: 20px;
`
